import { ApiResponse } from '../types/apis';

export function dataOrError<T>(data: ApiResponse<T>) {
  if (data.HasErrored) {
    throw new Error(data.Errors);
  }

  return data.Payload;
}
